import React from 'react'

import { useSelector } from 'react-redux'
import { selectSetFileDeletionStatuses } from 'store/file/file.selectors'
import { LoadingStatus } from 'types/loading'
import classes from '../../InputFile.module.css'

import GalleryItem from '../GalleryItem/GalleryItem'
import DownloadAll from '../DownloadAll/DownloadAll'

import { FileProps } from '../../../../../types/file'

interface GalleryProps {
  files: Map<File, FileProps>
  orderNumber?: string
  uploadedFiles?: FileProps[]
  uploadingFiles?: []
  deletable?: boolean
  onDelete?: (file: FileProps) => void
}

export const Gallery: React.FC<GalleryProps> = ({ files, uploadedFiles = [], orderNumber, deletable, onDelete }) => {
  const statuses = useSelector(selectSetFileDeletionStatuses)

  const numberOfFiles = (uploadedFiles.length || 0) + files.size
  return (
    <div className={classes.gallery} id="files_gallery">
      {numberOfFiles >= 2 && orderNumber ? <DownloadAll orderNumber={orderNumber} /> : null}
      {uploadedFiles.map((file: FileProps) => (
        <GalleryItem
          key={file.uuid}
          file={{
            uuid: file.uuid,
            name: file.name,
            isLoading: false,
            progress: 100,
            data: file.data,
            createdAt: file.createdAt,
          }}
          deletable={deletable}
          onDelete={onDelete}
          deleteLoading={statuses[file.uuid] === LoadingStatus.PENDING}
        />
      ))}
      {Array.from(files.entries()).map(([file, renderingRules]) => (
        <GalleryItem key={`${file.lastModified}${file.name}`} file={renderingRules} />
      ))}
    </div>
  )
}

export default Gallery
